import React, { useState } from 'react';
import { useStore } from 'effector-react';
import type { HSAlign, HSPos } from '@types';
import Button from '@components/Button';
import Tabbar from '@components/Tabbar';
import {
  $editingImageMarker,
  $editingImageMarkerApi,
} from '@stores/editingMarkerStores';
import WidgetItem from '@components/PlayerWidgets/WidgetItem';
import WidgetRowFont from '@components/PlayerWidgets/WidgetRowFont';
import WidgetRowAlign from '@components/PlayerWidgets/WidgetRowAlign';
import WidgetRowTitlePos from '@components/PlayerWidgets/WidgetRowTitlePos';
import WidgetRowOffset from '@components/PlayerWidgets/WidgetRowOffset';
import { IMAGE_MARKER_TITLE_DEFAULT } from '../constants';

const xyMap: Record<HSPos, { ox: number; oy: number }> = {
  bottom: { ox: 0, oy: -20 },
  top: { ox: 0, oy: 20 },
  left: { ox: 20, oy: 0 },
  right: { ox: -20, oy: 0 },
};

function TitleWidget() {
  const { marker } = useStore($editingImageMarker)!;
  const { titleSetting } = marker;
  const [tab, setTab] = useState(0);

  const handleFontSizeChange = (val: number) => {
    $editingImageMarkerApi.update((draft) => {
      draft.titleSetting.font.fontSize = val;
    });
  };

  const handleFontColorChange = (str: string) => {
    $editingImageMarkerApi.update((draft) => {
      draft.titleSetting.font.fontColor = str;
    });
  };

  const handleFontBgcChange = (str: string) => {
    $editingImageMarkerApi.update((draft) => {
      draft.titleSetting.background.bgColor = str;
    });
  };

  const handleAlignChange = (align: HSAlign) => {
    $editingImageMarkerApi.update((draft) => {
      draft.titleSetting.align = align;
    });
  };

  const handlePosChange = (pos: HSPos) => {
    const { ox, oy } = xyMap[pos];
    $editingImageMarkerApi.update((draft) => {
      draft.titleSetting.edge = pos;
      draft.titleSetting.ox = ox;
      draft.titleSetting.oy = oy;
    });
  };

  const handleOffsetChange = (key: 'ox' | 'oy') => (val: number) => {
    $editingImageMarkerApi.update((draft) => {
      draft.titleSetting[key] = val;
    });
  };

  const handleReset = () => {
    $editingImageMarkerApi.update((draft) => {
      draft.titleSetting = IMAGE_MARKER_TITLE_DEFAULT;
    });
  };

  const renderTab0 = () => {
    return (
      <>
        <WidgetRowFont
          fontSize={titleSetting.font?.fontSize}
          fontColor={titleSetting.font?.fontColor}
          bgColor={titleSetting.background.bgColor}
          onFontSizeChange={handleFontSizeChange}
          onFontColorChange={handleFontColorChange}
          onBgColorChange={handleFontBgcChange}
        />
        <WidgetRowAlign
          value={titleSetting.align}
          onChange={handleAlignChange}
        />
      </>
    );
  };

  const renderTab1 = () => {
    return (
      <>
        <WidgetRowTitlePos
          reversed
          value={titleSetting.edge}
          onChange={handlePosChange}
        />
        <WidgetRowOffset
          x={titleSetting.ox}
          y={titleSetting.oy}
          onXChange={handleOffsetChange('ox')}
          onYChange={handleOffsetChange('oy')}
        />
      </>
    );
  };

  return (
    <WidgetItem type="title" title="标题高级设置">
      <Tabbar
        className="mb-10"
        tabs={['样式设置', '位置设置']}
        activeIndex={tab}
        onChange={setTab}
      />
      {tab === 0 && renderTab0()}
      {tab === 1 && renderTab1()}
      <Button className="w-full" onClick={handleReset}>
        重置设置
      </Button>
    </WidgetItem>
  );
}

export default TitleWidget;
